import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { storage_keys } from '@/constant/configs';
import { i18n, countries } from '@/i18n-config';

const useCountrySelection = () => {
  const [selected, setSelected] = useState<boolean>(true);

  useEffect(() => {
    const locale = Cookies.get(storage_keys.locale);

    if (!locale) {
      // For now, we only support DE as default country. Requested by stakeholders.
      setCountryToCookie('DE');
      // setSelected(false);
    }
  }, []);

  const setCountryToCookie = (countryCode: countries) => {
    if (i18n.countries.includes(countryCode)) {
      Cookies.set(
        storage_keys.locale,
        `${i18n.defaultLanguage}-${countryCode}`,
        { expires: 7 }
      );
      // TODO: after activation of country modal it should reload the app in order to change url
      // window.location.reload();
    }
  };

  return { selected, setCountryToCookie };
};

export default useCountrySelection;
